var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColtDreaptaJos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 103,
    viewBox: "0 0 96 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 51L49 51L48.5 1",
    stroke: "black",
    strokeWidth: 4.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColtDreaptaJos);
export default __webpack_public_path__ + "static/media/colt_dreapta_jos.54df41dd13c174ce0b03785f95b7c465.svg";
export { ForwardRef as ReactComponent };